<template>
  <div>
      <!-- 头部 -->
      <top></top>
      <el-row class="exmain">
        <el-col :xs="1" :sm="3" :md="4" :lg="5" :xl="6"></el-col>
        <el-col :xs="22" :sm="18" :md="16" :lg="14" :xl="12">
            <div class="active-content-wrap" :style="{minHeight:height}">
                <p style="font-size:24px;color: #464343;" v-if="langSet == 'zh' || content.en_title.length == 0">{{content.title}}</p>
                <p style="font-size:24px;color: #464343;" v-if="langSet == 'en' && content.en_title.length > 0">{{content.en_title}}</p>
                <div class="ex-details-collectwrap">
                    <span class="ex-details-collect" v-if="content.isCollect == 0" @click="collectBtn(content.id,1)"><img  src="../../../assets/collect.png" alt=""></span>
                    <span class="ex-details-collect" v-if="content.isCollect == 1" @click="collectBtn(content.id,0)"><img  src="../../../assets/collect_en.png" alt=""></span>
                    <span class="ex-live" v-if="content.liveh > 0" @click="goLive(content.homeno)">{{$t('exhibitor.live')}}</span>
                </div>
                <div v-if="langSet == 'zh' || content.en_content.length == 0" class="active-content" v-html="content.content">{{content.content}}</div>
                <div v-if="langSet == 'en' && content.en_content.length > 0"  class="active-content" v-html="content.en_content">{{content.en_content}}</div>
            </div>
        </el-col>
        <el-col :xs="1" :sm="3" :md="3" :lg="5" :xl="5"></el-col>
      </el-row>
      <!-- 底部 -->
      <bottom></bottom>
  </div>
</template>

<script>
import top from "../../../components/top.vue";
import bottom from "../../../components/bottom.vue";
import { getActivityDetail, getCollect } from "@/api/api";
export default {
    components: { top, bottom},
    data() {
        return {
            content: {
                en_title: '',
                en_content: '',
            },
            height: '',
            langSet: ''
        };
    },
    created() { 
    },
    mounted() {
        this.langSet = localStorage.getItem('languageSet') || 'zh';
        this.memberid = localStorage.getItem('memberid');
        this.id = this.$route.query.id;
        this.getDetail(this.id);
        this.setHeight();
    },
    methods: {
        goLive(e){
            if(!this.$store.state.isLogin){
                this.$router.push({path: '/login'});
                return false;
            }
            window.open(e, '_blank');
        },
        setHeight(){
            this.height = window.innerHeight  - 175 + 'px';
        },
        getDetail(id) {
            let data = this.$qs.stringify({
                id
            })
            getActivityDetail(data).then(res=>{
                console.log(res.data.rst)
                if(res.data.errno == 0){
                    this.content = res.data.rst
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        collectBtn(id,state){
            if(!this.$store.state.isLogin){
                this.$router.push({path: '/login'});
                return false;
            }
            let data = this.$qs.stringify({
                memberid: this.memberid,
                type: 3,
                dataid: id,
                status: state
            })
            getCollect(data).then(res=>{
                //console.log(res)
                if(res.data.errno == 0){
                    this.content.isCollect = this.content.isCollect == 0 ? '1' : '0'
                }
            }).catch(err=>{
                console.log(err)
            })
        },
    }
}
</script>

<style>
.active-content-wrap{text-align: center;min-height: 620px;}
.active-content img{width: 100%;margin-bottom: 10px;}
.ex-details-collectwrap{display: flex;justify-content: flex-end;cursor: pointer;padding:10px;align-items: center;}
.ex-details-collectwrap img{width: 24px;}
.ex-live{background:#63BB46;border-radius:10px;text-align: center;width: 100px;height: 30px;line-height: 30px;color: #fff;font-size: 14px;cursor: pointer;margin-left: 5px;}
@media only screen and (max-width: 767px){
    .ex-details-collectwrap img{width: 0.4rem;}
    .ex-live{width: auto;height: 0.5rem;line-height: 0.52rem;font-size: 12px;padding: 0 0.1rem;}
}
</style>